import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const AOSInit = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-out-quart',
      once: true,
      offset: 0,
      disable: window.innerWidth < 768,
    });
  }, []);

  return null;
};

export default AOSInit;